export default __webpack_public_path__ + "static/media/logo-spora-white.ec2e91a0.png";